import React from 'react';
import { Box, Toolbar, Container, GlobalStyles, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../shared/Sidebar';
import TopBar from '../shared/TopBar';
import { Outlet } from 'react-router-dom';
import { useAdminContext } from '../context/AdminContext';

const AdminLayout = () => {
  const { sidebarOpen } = useAdminContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const drawerWidth = isMobile ? 0 : (sidebarOpen ? 220 : 56);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', '@media print': { display: 'block', minHeight: 'auto' } }}>
      <GlobalStyles styles={{
        '@media print': {
          '@page': {
            size: 'auto',
            margin: '0mm', // Removes browser headers and footers
          },
          body: {
            padding: '20mm', // Add physical padding so content is not cut off
          }
        }
      }} />
      <Box sx={{ '@media print': { display: 'none' } }}>
        <TopBar />
        <Sidebar />
      </Box>
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          p: { xs: 2, sm: 3 }, 
          width: { xs: '100%', md: `calc(100% - ${drawerWidth}px)` }, 
          transition: 'width 0.22s ease',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          '@media print': {
            width: '100%',
            p: 0,
            overflow: 'visible',
            display: 'block'
          }
        }}
      >
        <Toolbar sx={{ '@media print': { display: 'none' } }} />
        <Container maxWidth="xl" sx={{ mt: 2, '@media print': { mt: 0, maxWidth: '100%', padding: 0 } }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default AdminLayout;
